<sm-title-bar [headerCustomTemplate]="addButton" pageTitle="{{ 'purchases.title' | translate }}" 
[backWithParams]="true">

  <ng-template #addButton>
    <div class="d-flex search-field">
      <!-- <button mat-button aria-label="option menu" color="accent" (click)="openInventoryItems()">
      <mat-icon class="material-icons-round try" [inline]="true">add_circle</mat-icon>
      </button> -->
      <!-- <mat-menu #menu="matMenu">
        <button  mat-menu-item (click)="onRecordUsage()" >
          <mat-icon class="material-icons-outlined">edit</mat-icon>
          <span>Record usage/finish</span>
        </button>
        <button  mat-menu-item (click)="OnIncreaseStock()">
          <mat-icon class="material-icons-outlined">arrow_upward</mat-icon>
          <span>Increase stock</span>
        </button>
      </mat-menu> -->
      
  </div>
  </ng-template>
</sm-title-bar>


<div class="bradcamp_inventory" *ngIf="!loader" >
  <div class="row">
    <div class="col-sm-3">
      <div class="overall_count_s">
      <p>This month</p>
      <h3>{{overview?.currency_symbol ? overview?.currency_symbol : ''}}{{monthlyPurchase.toFixed(2)}}</h3>
      </div>
    </div>
    <div class="col-sm-3">
      <div class="overall_count_s" style="border-right: none !important;">
      <p>Today</p>
      <h3>{{overview?.currency_symbol ? overview?.currency_symbol : ''}}{{todayPurchase.toFixed(2)}}</h3>
      </div>
    </div>
  
    <div class="col-sm-6">
      <div class="view_items_btn">
        <button mat-flat-button color="primary" mat-button aria-label="option menu" style="color: #fff;background: #ffc107;" (click)="openLinkURL('https://market.lookzup.com/purchase')">
        Go to Marketplace
        </button>
      </div>
      <div class="view_items_btn" style="margin-right: 10px;">
        <button mat-flat-button color="primary" mat-button aria-label="option menu" (click)="openInventoryItems()">
        <mat-icon>add</mat-icon>  Record purchase
        </button>
      </div>
    </div>
  </div>
  </div>


<!-- <div class="experse_heading" style="border-top: 1px solid #ddd;margin-top: 14px !important;padding-top: 22px;margin-bottom: 0px;">
<div>
<p style="position: relative;top: 12px;font-weight: normal;font-size: 20px;color: #4f4f4f;">
  {{ 'purchases.subtitle1' | translate }}: <span class="month_headingt">{{monthlyPurchase.toFixed(2)}} </span></p>
</div>

<div class="create_btn_sd">
  <button (click)="openInventoryItems()" mat-flat-button color="accent">
    <mat-icon>add</mat-icon> Record purchase
</button>
</div>
</div>

<div class="btn_opet" style="margin-bottom: 50px;">
  <p style="position: relative;top: 12px;font-weight: normal;font-size: 20px;color: #4f4f4f;">
   {{ 'purchases.subtitle2' | translate }}: <span class="month_headingt">{{todayPurchase.toFixed(2)}}</span></p>
</div> -->

<!-- <div style="background: #ffc107; border-radius: 4px; margin: 40px 0 30px;" (click)="openInventoryItems()" *ngIf="!loader">
  <div class="cdf_srd"  style="border-bottom: 1px solid lightgray;">
    <div class="book_text" style="padding: 16px !important;">
        <div class="entry_sec">
            <mat-icon style="color:#222;position: relative;
            top: 9px;">navigate_next</mat-icon>
        </div>
        <p style="color:black;    font-size: 20px;    margin: 0 0 5px;

        font-weight: 500;" >All inventory items</p>
        <span>Check the list with latest stock data</span>
    </div>
</div>
</div>  -->



<mat-card *ngIf="!loader && purchaseListData.length > 0">
  <sm-title-bar></sm-title-bar>
  <div class="rounded-3 bg-light">
    <sm-data-table [columnHeaders]="tableDisplayColumn" [dataSource]="purchaseListData" [showImageColumn]="true"  [imageTemplate]="image" [showMenuButton]="true" [menuDropdownTemplate]="menuTemplate"></sm-data-table>
  </div>
</mat-card>


<ng-template #menuTemplate let-rowvalue >
  
  <button  mat-menu-item (click)="onEdit(rowvalue)" *ngIf="rowvalue.purchase_status == 2" [disabled]="checkDisablity(rowvalue)">
    <mat-icon class="material-icons-outlined">edit</mat-icon>
    <span>{{ 'purchases.op1_edit' | translate }}</span>
  </button>
  <button  mat-menu-item (click)="recordPayment(rowvalue)" *ngIf="rowvalue.amount_due > 0">
    <mat-icon class="material-icons-outlined">edit</mat-icon>
    <span>Record payment</span>
  </button>
  <button  mat-menu-item (click)="markPurchased(rowvalue)" *ngIf="rowvalue.purchase_status == 2" [disabled]="!isOwner">
    <mat-icon class="material-icons-outlined">check</mat-icon>
    <span>{{ 'purchases.op2_mark_purchasse' | translate }}</span>
  </button>
  <button  mat-menu-item (click)="onPurchasePending(rowvalue)" *ngIf="rowvalue.purchase_status == 1" [disabled]="!isOwner">
    <mat-icon class="material-icons-outlined">schedule</mat-icon>
    <span>{{ 'purchases.op3_purchase_pending' | translate }}</span>
  </button>
  <button  mat-menu-item (click)="onPurchaseCancelled(rowvalue)" *ngIf="rowvalue.purchase_status == 1 || rowvalue.purchase_status == 2" [disabled]="!isOwner">
    <mat-icon class="material-icons-outlined">close</mat-icon>
    <span>{{ 'purchases.op4_cancel_purchase' | translate }}</span>
  </button>
  <button  mat-menu-item (click)="onPurchaseDeleted(rowvalue)" *ngIf="rowvalue.purchase_status == 2 || rowvalue.purchase_status == 3" [disabled]="checkDisablity(rowvalue)">
    <mat-icon class="material-icons-outlined">delete</mat-icon>
    <span>{{ 'purchases.op4_delete' | translate }}</span>
  </button>
  
</ng-template>

<ng-template #image let-objValue>
  <div style="position: relative;">
    <img
      [src]="
        objValue['image_thumb_url'] !== null && objValue['image_thumb_url'] !== 'null' && objValue['image_thumb_url'] !== ''
          ? objValue['image_thumb_url']
          : '../../../../assets/images/photo.png'
      "
      class="img-fluid rounded-circle" style="border: 1px solid lightgray;"
    />
    
    <mat-icon style="height: 20px;
    width: 20px;
    border-radius: 50%;
    display: block;
    position: absolute;
    bottom: -5px;
    font-size: 20px !important;
    left: 25px;
    background-color: green;
    color: white;" *ngIf="objValue['purchase_status'] == 1" class="material-icons-round">check</mat-icon>
    <mat-icon style="height: 20px;
    width: 20px;
    border-radius: 50%;
    display: block;
    position: absolute;
    bottom: -5px;
    font-size: 20px !important;
    left: 25px;
    background-color: #ffc107;
    color: white;" *ngIf="objValue['purchase_status'] == 2" class="material-icons-round">schedule</mat-icon>
    <mat-icon style="height: 20px;
    width: 20px;
    border-radius: 50%;
    display: block;
    position: absolute;
    bottom: -5px;
    font-size: 20px !important;
    left: 25px;
    background-color: red;
    color: white;" *ngIf="objValue['purchase_status'] == 3" class="material-icons-round">close</mat-icon>
    </div>
</ng-template>

<mat-paginator
*ngIf="!loader && purchaseListData.length > 0"
  class="mt-4"
  [length]="datalength"
  [pageSize]="25"
  (page)="onPageChange($event)"
>
</mat-paginator>



<!-- <ng-container>

  <div class="merchant_detail_sec"  >
    <div class="mrt_offer">
      <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#b0b0b0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line></svg>
  
      <h3>
        Inventory items are coming
      </h3>
      <p>
        We are working hard day and night to bring this for you.
      </p>
    </div>
  </div>   
</ng-container> -->


  <!-- placeholder html start -->
  <div class="placeholder_started" *ngIf="!loader && purchaseListData.length == 0">
        <div class="row">
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/purchase-record.jpg">
                 </div>
                 <mat-card-title>No purchase record</mat-card-title>
                 <mat-card-content>So far no purchase data added for this business. You can start adding one to track and manage your inventory.
                </mat-card-content>
                 <!-- <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary" (click)="openLink('https://lookzup.com/help')">
                       <mat-icon>help</mat-icon>
                      See the help
                    </button>
                 </div> -->
                 <div class="watch_vc_btn">
                  <button mat-flat-button color="primary" mat-button aria-label="option menu" (click)="openInventoryItems()">
                    <mat-icon>add</mat-icon>  Record purchase
                    </button>
               </div> 
                 </div>
              </mat-card>
           </div>
          </div>
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/add-purchase.jpg">
                 </div>
                 <mat-card-title>How to add purchase record?</mat-card-title>
                 <mat-card-content>Check our <span class="ghtunderline" (click)="openLink('https://lookzup.com/help')">help document</span> on adding new purchase records against a business. Get the help and start. 
                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary" (click)="openLink('https://lookzup.com/help')">
                       <mat-icon>help</mat-icon>
                      See the help
                    </button>
                 </div>
                
                 </div>
              </mat-card>
           </div>
          </div>
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/helpsupport.png">
                 </div>
                 <mat-card-title>Facing any issue?</mat-card-title>
                 <mat-card-content>For any difficulties in creating a new purchase record or in issue while retrieving old data, contact our support team.
                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary"  (click)="opencontact()">
                       <mat-icon>support_agent</mat-icon>
                       Contact support 
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
        </div>
  </div> 
  <!-- placeholder html end -->